export * from './waste-disposal-list.component';
export * from './waste-disposal-view.component';